import { BoxLoading } from "./components/boxLoading";
import { FullScreenLoading } from "./components/fullScreen";
import { Spinner } from "./components/spinner";

export { BoxLoading, FullScreenLoading, Spinner };
